import { Component, Inject, TemplateRef, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { TopnavService } from '../header/topnav/topnav.service';
import { FormControl, FormGroup, Validators, FormBuilder, FormGroupDirective, NgForm, AbstractControl, ValidatorFn } from '@angular/forms';
import { BreadcrumbService } from '../header/breadcrumb/breadcrumb.service';
import { SharedService } from '../common/shared.service';
import { ValidateService } from '../common/validate.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router'
import { HttpClient } from "@angular/common/http";
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { PortalService } from "../services/portal.service";
import { TextMaskModule } from 'angular2-text-mask';
import { DialogsService } from '../dialogs/dialogs.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ToastrService } from "ngx-toastr";
import { ModalDirective, BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment-timezone'
import {ErrorStateMatcher} from '@angular/material/core';
import { environment } from '../../environments/environment';

export class StateMatcherValidator implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      return !!(control && control.invalid && (control.dirty || control.touched));
    }
  }

export class EmailValidators extends Validators{

    static checkDomain(forbiddenDomains : string[]): ValidatorFn{
      return(control: AbstractControl): {[key:string]: boolean} | null => {
        
        if (!environment.production) {
           // return null;
        }
    
        let match = /^\w+[-\.\w]*@(\w+[-\.\w]*?\.\w{2,4})$/.exec(control.value);
        if (control && control.value && match && match[1] && forbiddenDomains.indexOf(match[1].toLowerCase()) >= 0) {
            return { 'emailDomain': true };
        }
        return null;
      }
    }
   
}

declare function unescape(s: string): string;

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Registration Form - /register
 **/
@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    animations: [
        trigger('myAwesomeAnimation', [
            state('small', style({
                transform: 'scale(1)',
            })),
            state('large', style({
                transform: 'scale(1.2)',
            })),
            transition('small => large', animate('300ms ease-in')),
        ]),
    ]
})

export class RegisterComponent implements OnInit, AfterViewInit, OnDestroy {
    private paramSub: ISubscription;
    refUrl: string;
    errMsg: string;
    getEmail: any;
    content: any;
    message: string;
    captchaImageUrl: string;

    @ViewChild(ModalDirective) modal: ModalDirective;
    @ViewChild('staticModal') public staticModal: ModalDirective;
    @ViewChild('infoModal') public infoModal: ModalDirective;
    getUserData: any;
    maskICNo: any;
    state: string = 'small';
    loading: boolean = false;
    checkIC: any;

    nonCiti: boolean;
    citi: boolean;
    permanentResident: boolean;
    modalRef: BsModalRef;
    maskCitizen: any;
    maskForeigner: any;
    countriesByName: any[];

    public isCaptchaVerified: boolean = false;
    breadcrumb: any;
    isValid: any;
    topicID: number;
    public translatedText: string;
    public supportedLanguages: any[];
    result: any[];
    getResult: any;
    private subscriptionLang: ISubscription;
    public matcher: StateMatcherValidator;
    public matcher2: StateMatcherValidator;
    //@Output() langChange = new EventEmitter();
    //@ViewChild('tele') tele: ElementRef;
    //@ViewChild('capt') capt: ElementRef;
    //@ViewChild('icnum') icnum: ElementRef;
    //@ViewChild('telefori') telefori: ElementRef;
    //@ViewChild('name') name: ElementRef;
    //@ViewChild('namefori') namefori: ElementRef;
    //@ViewChild('psport') psport: ElementRef;
    
    countries: any[];
    countriesCode: any[];
    filteredCountries: any[];
    filteredCountriesName: any [];
    //registration_Form: FormGroup;
    public citizenFormGrp: FormGroup;
    public noncitiFormGrp: FormGroup;
    public kad_pengenalan: FormControl;
    public nama_penuh: FormControl;
    public emel: FormControl;
    public telefon: FormControl;
    public codeTelefon: FormControl;
    public country: FormControl;
    public passport: FormControl;
    public country_pr: FormControl;
    public passport_pr: FormControl;
    public nama_penuhf: FormControl;
    public emelf: FormControl;
    public telefonf: FormControl;
    public codeTelefonf: FormControl;
    public captcha: FormControl;
    public citizenValue: any;
    changeCitizen = true;
    country_my = '';
    resetCap = false;
    public supportedLangs: any[];
    UAPLang;
    lang;
    languageId;
    public subscriptionFontType: ISubscription;
    public fontType: string = 'Arial';
    private subscriptionFontSize: ISubscription;

    public fontSize: any = {
        "sizeS" : "14px",
        "sizeM" : "19px",
        "sizeL" : "23px",
        "no_styles" : "0.9em"
    };

    public currSearchVal: string ='';
    public fnamePlaceHolder: string ='';
    public domainList: any;
    public registerOff: boolean = false;

    constructor(private pageTitle: Title,
        fb: FormBuilder,
        @Inject(APP_CONFIG) private config: AppConfig,
        private breadcrumbService: BreadcrumbService,
        private translate: TranslateService,
        private sharedService: SharedService,
        private elementRef: ElementRef,
        private validateService: ValidateService,
        private http: HttpClient,
        private router: Router,
        private route: ActivatedRoute,
        private portalservice: PortalService,
        textMask: TextMaskModule,
        private dialogsService: DialogsService,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private topnavservice: TopnavService,
    ) {

        this.sharedService.registerOff.subscribe((data)=> {
           
            if (data) {
                this.registerOff = data;
                console.log('registerOffline:', this.registerOff);
            }

        });
        this.sharedService.getForbiddenList().subscribe((forbiddenDomains)=>{
            //console.log(forbiddenDomains);
            this.domainList = forbiddenDomains;
            this.loadFormControl();
        });

        this.lang = translate.currentLang;

        /*this.registration_Form = fb.group({
            "Name": this.nama_penuh,
            "Email": this.emel,
            "Phone": this.telefon,
            // "Code": this.codeTelefon,
            "icNo": this.kad_pengenalan,
            "captcha": this.captcha
        });*/

        this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {

            const myLang = translate.currentLang;

            if (myLang == 'en') {
                translate.get('HOME').subscribe((res: any) => {
                    this.lang = 'en';
                    this.languageId = 1;
                });

            }
            if (myLang == 'ms') {
                translate.get('HOME').subscribe((res: any) => {
                    this.lang = 'ms';
                    this.languageId = 2;
                });
            }

            if (this.topnavservice.flagLang) {
                this.getUserType(this.languageId);
                if (this.domainList) {
                    this.resetForm();
                    this.resetCitiToDefault();
                    this.enableFormControls(false);
                }
              
                
                this.fnamePlaceHolder = ''; //this.translate.instant('register.label.nameplh'); 
            }

            setTimeout(() => {
                this.translate.get('pageTitle.home').subscribe((title: string) => {
                    title = title + this.translate.instant('home.breadcrumb.register');
                    this.sharedService.setTitle(title);
                });
            }, 500);

        });

        this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
            this.fontSize = data;
            $('.mat-input-placeholder').css('font-size', this.fontSize.sizeS);
        });
        
        this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
            this.fontType = data;
            $('.mat-select-value-text span').css('font-family', this.fontType);
        });
        
          this.matcher = new StateMatcherValidator();
          this.matcher2 = new StateMatcherValidator();
    }


    confirm(): void {
        this.message = 'Confirmed!';
        this.modal.hide();
    }

    decline(): void {
        this.message = 'Declined!';
        this.modal.hide();
    }

    numberMobile(e){
        e.target.value = e.target.value.replace(/[^\d]/g,'');
        return false;
    }

    getPhoneMinLength(countryCode) {
        if (countryCode == '60') {
            return "9";
        } else {
            return "6";
        }
    }

    getUserType(lang) {
        this.loading = true;
        this.portalservice.getUserType(lang)
            .subscribe(
                userData => {
                    let filteredUserType = userData.userTypeList.filter((i) => {
                        return i.userTypeActiveFlag === true;
                    });
                    this.getUserData = filteredUserType;
                    this.loading = false;
                }, Error => {
                    this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
                    this.loading = false;
                }
            );
    }

    openModal(template: TemplateRef<any>, content) {
      
        this.modalRef = this.modalService.show(template);
        this.content = content;
    }

    private captchaUrl: string = this.config.urlCaptcha;
    private registerUrl: string = this.config.urlRegister;
    private uapstagingUrl: string = this.config.urlUapRegistration; //environment.uapRegistrationURL; //this.config.urlUapStaging;

    ngOnDestroy() {
        this.subscriptionLang.unsubscribe();
        this.subscriptionFontSize.unsubscribe();
        this.subscriptionFontType.unsubscribe();
        this.paramSub.unsubscribe();
        this.matcher = null;
    }

    getErrorMessage() {
        return this.emel.hasError('required') ? this.translate.instant('register.err.email') :
            this.emel.hasError('pattern') ? this.translate.instant('register.pattern.email') :
            this.emel.hasError('emailDomain') ? this.translate.instant('register.pattern.dispemail', {domain: this.emel.value.split('@')[1]}) :
            //this.emel.hasError('emailDomain') ? this.emel.value :
                '';
                
      }

      getErrorMessage2() {
       return this.emelf.hasError('required') ? this.translate.instant('register.err.email') :
            this.emelf.hasError('pattern') ? this.translate.instant('register.pattern.email') :
            this.emelf.hasError('emailDomain') ?  this.translate.instant('register.pattern.dispemail', {domain: this.emelf.value.split('@')[1]}) :
                '';
                
      }

    
    ngOnInit() {

        this.fnamePlaceHolder = ''; //this.translate.instant('register.label.nameplh'); 
        this.captchaImageUrl = this.captchaUrl + 'captcha' + '?random=' + Math.random();

        this.paramSub = this.route.params.subscribe(params => {
            if (params['id']) {
                console.log(params['id']);
                this.languageId = params['id'];
                if (this.languageId === '1') {
                    this.translate.setDefaultLang('en');
                    this.translate.use('en');
                } else {
                    this.translate.setDefaultLang('ms');
                    this.translate.use('ms');
                }
            } else if (!this.languageId) {
                if (localStorage.getItem('langID')) {
                    this.languageId = localStorage.getItem('langID');
                } else {
                    this.languageId = 1;
                }
            }

          

            // this.citizenFormGrp.get('telefon').disable();
            this.refUrl = location.search.split('forward_url=')[1];
            this.getUserType(this.languageId);
           
        });

      
    }

    loadFormControl() {
        this.maskCitizen = this.validateService.getMask().telephone;
        this.maskForeigner = this.validateService.getMask().telephonef;
        this.maskICNo = this.validateService.getMask().icno;
        this.getCountryName('name');
        //this.getCountryCode();
        this.breadcrumb = this.breadcrumbService.getBreadcrumb();
        this.breadcrumb = this.breadcrumb.name = '';
        this.isValid = this.breadcrumbService.getValid();
        this.isValid = this.isValid.value = true;
        this.kad_pengenalan = new FormControl('', [Validators.required, Validators.pattern('^[0-9-]{14}$')]),
            this.nama_penuh = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern(2, 80).name)]), 
            this.emel = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern().email), EmailValidators.checkDomain(this.domainList)]),
            this.telefon = new FormControl('', [Validators.required]),
            this.codeTelefon = new FormControl('', [Validators.required]),
            this.country = new FormControl('', [Validators.required]),
            this.passport = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern(6, 10).passport)]), //A1234567 or AB123456
            this.country_pr = new FormControl(''),
            this.passport_pr = new FormControl('', [Validators.pattern(this.validateService.getPattern(6, 10).passport)]), //A1234567 or AB123456
            this.nama_penuhf = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern(2, 80).name)]),
            this.emelf = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern().email), EmailValidators.checkDomain(this.domainList)]),
            this.telefonf = new FormControl('', [Validators.required]),
            this.codeTelefonf = new FormControl('', [Validators.required]),
            this.captcha = new FormControl('', [Validators.required]),
            this.citizenFormGrp = new FormGroup({
                kad_pengenalan: this.kad_pengenalan,
                nama_penuh: this.nama_penuh,
                emel: this.emel,
                telefon: this.telefon,
                codeTelefon: this.codeTelefon,
                country: this.country,
                passport: this.passport,
                country_pr: this.country_pr,
                passport_pr: this.passport_pr,
                nama_penuhf: this.nama_penuhf,
                emelf: this.emelf,
                telefonf: this.telefonf,
                codeTelefonf: this.codeTelefonf,
                captcha: this.captcha,
            });
        //this.flagGetCaptcha = true;
        this.removeNonCitizenCtrl();
    }

    ngAfterViewInit() {

        this.maskCitizen = this.validateService.getMask().telephone;
        this.maskForeigner = this.validateService.getMask().telephone;
        this.maskICNo = this.validateService.getMask().icno;

        // Get Title and Sent to GA
        this.translate.get('pageTitle.home').subscribe((title: string) => {
            title = title + this.translate.instant('home.breadcrumb.register');
            this.sharedService.setTitleAndGtag(title);
        });

        this.sharedService.loadFontSizeData();
        this.sharedService.loadFontTypeData();
        setTimeout(()=> {
            window.scrollTo(0, 0);
            this.enableFormControls(false);
        }, 600);
      
    }

    charCount(name) {
        if (name) {
            return name.replace(/ /g,"").length;
        } else {
            return 0;
        }
    }

    limitKeypress(event, value, maxLength) {
        let newValue =  value.replace(/ /g,"");
        if (newValue && newValue.length >= maxLength) {
            event.preventDefault();
        }
    }

    selectionChange(event) {
        let flr = this.countries.filter((element, index) => {
            return (element.countryDialCode === event.value);
        });
        if (flr[0] && flr[0].countryId && this.citizenFormGrp.get('country')) {
            //this.citizenFormGrp.get('country_pr').setValue(flr[0].countryId);
            this.citizenFormGrp.get('country').setValue(flr[0].countryId);
        }
        this.sharedService.loadFontSizeData();
        this.sharedService.loadFontTypeData();
    }

    openDialog() {
        this.dialogsService
            .confirm('Success!', 'Registration successful!')
            .subscribe(res => this.getResult = res);
    }

    animateMe() {
        this.state = (this.state === 'small' ? 'large' : 'small');
    }

    isCurrentLang(lang: string) {
        return lang === this.translate.currentLang;
    }

    reCreateCaptchas(refresh?) {
        this.resetCap = true;
        if (refresh) {
            this.captchaImageUrl = this.captchaUrl + 'captcha' + '?random=' + Math.random();
        }
        
        this.citizenFormGrp.controls["captcha"].reset();
        this.isCaptchaVerified = false;
    }
   
    //show = true;
    chgeCitizen() {

        this.currSearchVal='';

        this.resetCountryFilter();
      
        this.checkIC = true;
       
        this.changeCitizen = this.citizenValue;
        this.reCreateCaptchas();
        console.log(this.citizenValue);
      
        if ((this.citizenValue == 2) || (this.citizenValue == 6)) {
            this.citi = false;
            this.permanentResident = false;
            this.nonCiti = true;
            this.removeCitizenCtrl();
            this.removePRTRCtrl();
            this.addNonCitizenCtrl();
        } else if ((this.citizenValue == 3) || (this.citizenValue == 7)) {
            this.citi = true;
            this.permanentResident = true;
            this.nonCiti = false;
            this.removeNonCitizenCtrl();
            this.removeCitizenCtrl();
            this.addPRTRCtrl();
            this.citizenFormGrp.get('codeTelefon').setValue('60');
            this.fnamePlaceHolder = this.translate.instant('register.label.namehint');
        } else {
            this.citi = true;
            this.permanentResident = false;
            this.nonCiti = false;
            this.removeNonCitizenCtrl();
            this.removePRTRCtrl();
            this.addCitizenCtrl();
            this.citizenFormGrp.get('codeTelefon').setValue('60');
            this.fnamePlaceHolder = this.translate.instant('register.label.namehint');
        }

        this.enableFormControls(true);       
       
    }


    addCitizenCtrl() {
        this.citizenFormGrp.addControl('kad_pengenalan', this.kad_pengenalan);
        this.citizenFormGrp.addControl('nama_penuh', this.nama_penuh);
        this.citizenFormGrp.addControl('emel', this.emel);
        this.citizenFormGrp.addControl('telefon', this.telefon);
        this.citizenFormGrp.addControl('codeTelefon', this.codeTelefon);
        this.resetCitizenCtrl();
    }

    removeCitizenCtrl() {
        this.citizenFormGrp.removeControl('kad_pengenalan');
        this.citizenFormGrp.removeControl('nama_penuh');
        this.citizenFormGrp.removeControl('emel');
        this.citizenFormGrp.removeControl('telefon');
        this.citizenFormGrp.removeControl('codeTelefon');
    }

    resetCitizenCtrl() {
        this.kad_pengenalan.reset();
        this.nama_penuh.reset();
        this.emel.reset();
        this.telefon.reset();
        this.codeTelefon.reset();
    }

    addPRTRCtrl() {
        this.citizenFormGrp.addControl('kad_pengenalan', this.kad_pengenalan);
        this.citizenFormGrp.addControl('nama_penuh', this.nama_penuh);
        this.citizenFormGrp.addControl('emel', this.emel);
        this.citizenFormGrp.addControl('telefon', this.telefon);
        this.citizenFormGrp.addControl('codeTelefon', this.codeTelefon);
        this.citizenFormGrp.addControl('country_pr', this.country_pr);
        this.citizenFormGrp.addControl('passport_pr', this.passport_pr);
        this.resetPRTRCtrl();
    }

    removePRTRCtrl() {
        this.citizenFormGrp.removeControl('kad_pengenalan');
        this.citizenFormGrp.removeControl('nama_penuh');
        this.citizenFormGrp.removeControl('emel');
        this.citizenFormGrp.removeControl('telefon');
        this.citizenFormGrp.removeControl('codeTelefon');
        this.citizenFormGrp.removeControl('country_pr');
        this.citizenFormGrp.removeControl('passport_pr');
    }

    resetPRTRCtrl() {
        this.kad_pengenalan.reset();
        this.nama_penuh.reset();
        this.emel.reset();
        this.telefon.reset();
        this.codeTelefon.reset();
        this.country_pr.reset();
        this.passport_pr.reset();
    }



    addNonCitizenCtrl() {
        this.citizenFormGrp.addControl('country', this.country);
        this.citizenFormGrp.addControl('passport', this.passport);
        this.citizenFormGrp.addControl('nama_penuhf', this.nama_penuhf);
        this.citizenFormGrp.addControl('emelf', this.emelf);
        this.citizenFormGrp.addControl('telefonf', this.telefonf);
        this.citizenFormGrp.addControl('codeTelefonf', this.codeTelefonf);
        this.resetNonCitizenCtrl();
        
    }

    removeNonCitizenCtrl() {
        this.citizenFormGrp.removeControl('country');
        this.citizenFormGrp.removeControl('passport');
        this.citizenFormGrp.removeControl('nama_penuhf');
        this.citizenFormGrp.removeControl('emelf');
        this.citizenFormGrp.removeControl('telefonf');
        this.citizenFormGrp.removeControl('codeTelefonf');
    }


    resetNonCitizenCtrl() {
    
        this.country.reset();
        this.passport.reset();
        this.nama_penuhf.reset();
        this.emelf.reset();
        this.telefonf.reset();
        this.codeTelefonf.reset();
        
    }

    resetForm() {
      
            this.resetCitiToDefault();
            this.enableFormControls(false);
            this.citizenValue = null;
            this.isCitizen();
            this.resetCitizenCtrl();
            this.resetPRTRCtrl();
            this.resetNonCitizenCtrl();
            this.citizenFormGrp.get('codeTelefon').setValue('60');
        this.captcha.reset();
    }

    resetCitiToDefault() {
      
        this.citi = true;
        this.permanentResident = false;
        this.nonCiti = false;
        this.currSearchVal='';
        //this.resetCountryFilter();
        this.checkIC = true;
        this.reCreateCaptchas();
        this.removeNonCitizenCtrl();
        this.addCitizenCtrl();
        this.citizenFormGrp.get('codeTelefon').setValue('60');
        this.citizenValue = 0;
        //this.changeCitizen = this.citizenValue;
    }
    

    enableFormControls(isEnable: boolean){


        Object.keys(this.citizenFormGrp.controls).forEach(key => {
            if (isEnable) {
                this.citizenFormGrp.get(key).enable();
            } else {
                this.citizenFormGrp.get(key).disable();
            }
        });
      
        
      }
    
    verifyUserCaptcha(formValues: any) {
      
        let capText = formValues.captcha;
        if (capText.length === 6) {

            let body = { "captcha": null };
            body.captcha = capText;
            console.log(JSON.stringify(body));
            this.portalservice.verifyCaptcha(JSON.stringify(body)).subscribe((data) => {
                console.log(data);
                if (data.statusCode) {
                    if (data.statusCode === 'SUCCESS') {
                        this.isCaptchaVerified = true;
                    } else {
                        this.isCaptchaVerified = false;
                    }
                } else {
                    this.isCaptchaVerified = false;
                }
            },
                error => {
                    this.isCaptchaVerified = false;
                    this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
                });
        } else {
            this.isCaptchaVerified = false;
        }
    }

    citizenReg(formValues: any) {
        localStorage.setItem('registerinfo',null);

        let body = {
            "country": {
                "countryId": null
            },
            "identificationNo": null,
            "phoneNo": null,
            "email": null,
            "fullName": null,
            "userType": {
                "userTypeId": null
            },
            "passportNo": null,
            "isEmail": true,
            "isMobilePhone": false,
            "captcha": null
        };

        let subStrPhone = '';
        let subStrPhone2 = '';
        if (formValues.codeTelefon == '60') {

            subStrPhone = (formValues.telefon).substring(0, 1);
            if (subStrPhone == '0') {
                subStrPhone = (formValues.telefon).substring(1)
         
            } else {
                subStrPhone = formValues.telefon;
         
            }
        } else {
            subStrPhone = formValues.telefon;
         
        }

        if (formValues.codeTelefonf == '60') {

            subStrPhone2 = (formValues.telefonf).substring(0, 1);
            if (subStrPhone2 == '0') {
                subStrPhone2 = (formValues.telefonf).substring(1)
            } else {
                subStrPhone2 = formValues.telefonf;
            }
        } else {
            subStrPhone2 = formValues.telefonf;
        }
        
        if ((formValues.kad_pengenalan) && (formValues.passport_pr)) {
            body.country.countryId = formValues.country_pr;
            body.userType.userTypeId = this.citizenValue;
            body.identificationNo = formValues.kad_pengenalan;
            body.email = formValues.emel;
            body.phoneNo = formValues.codeTelefon + '*' + subStrPhone; //formValues.telefon;
            body.fullName = formValues.nama_penuh.replace(/\u2018/gi, '\'')
            .replace(/\u2019/gi, '\'')
            .replace(/\u201C/gi, '\'')
            .replace(/\u201D/gi, '\'');
            body.passportNo = formValues.passport_pr;

        } else if (formValues.country) {
            body.country.countryId = formValues.country;
            body.userType.userTypeId = this.citizenValue;
            body.identificationNo = formValues.passport;
            body.email = formValues.emelf;
            body.phoneNo = formValues.codeTelefonf + '*' + subStrPhone2;//formValues.telefonf;
            body.fullName = formValues.nama_penuhf.replace(/\u2018/gi, '\'')
            .replace(/\u2019/gi, '\'')
            .replace(/\u201C/gi, '\'')
            .replace(/\u201D/gi, '\'');
        } else {
            body.country.countryId = 152;
            body.userType.userTypeId = this.citizenValue;
            body.identificationNo = formValues.kad_pengenalan;
            body.email = formValues.emel;
            body.phoneNo = formValues.codeTelefon + '*' + subStrPhone; //formValues.telefon;
            body.fullName = formValues.nama_penuh.replace(/\u2018/gi, '\'')
            .replace(/\u2019/gi, '\'')
            .replace(/\u201C/gi, '\'')
            .replace(/\u201D/gi, '\'');
        }

        if (formValues.captcha) {
            body.captcha = formValues.captcha;
        }

       
        if (this.refUrl) {
            this.portalservice.createForAgency(body, unescape(this.refUrl))
                .subscribe(
                    data => {
                        if (this.lang == 'ms') {
                            this.UAPLang = 'my';
                        } else {
                            this.UAPLang = 'en';
                        }
                        if (!!data.user) {
                            //window.location.href = this.uapstagingUrl + this.UAPLang + "&tag=" + data.user.tag;
                            window.location.replace(this.uapstagingUrl + this.UAPLang + "&tag=" + data.user.tag);
                            this.resetCitiToDefault();
                        } else {
                            let extraMsg = '';
                            if (this.lang == 'ms') {
                                extraMsg = '<br>Kembali ke ' + '<a href="'+ unescape(this.refUrl) + '">'+unescape(this.refUrl)+'</a> untuk teruskan.'; 
                            } else {
                                extraMsg = '<br>Return to ' + '<a href="'+ unescape(this.refUrl) + '">'+unescape(this.refUrl)+'</a> to continue.'; 
                            }
                            this.errMsg = data.statusDesc+ extraMsg;
                            this.infoModal.show();
                        }
                    },
                    error => {
                        this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
                    });
        } else {

            this.portalservice.create(body)
                .subscribe(
                    data => {
                        if (this.lang == 'ms') {
                            this.UAPLang = 'my';
                        } else {
                            this.UAPLang = 'en';
                        }
                        if (!!data.user) {
                            //window.location.href = this.uapstagingUrl + this.UAPLang + "&tag=" + data.user.tag;
                            window.location.replace(this.uapstagingUrl + this.UAPLang + "&tag=" + data.user.tag);
                            this.resetCitiToDefault()
                        } else {
                            //this.sharedService.registerInfo.next(body);
                            localStorage.setItem('registerinfo', JSON.stringify(body));
                            this.errMsg = data.statusDesc;
                            this.infoModal.show();
                        }
                     
                    },
                    error => {
                        this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
                    });

        }

    }


    isCitizen() {
        if ((this.citizenValue == 2) || (this.citizenValue == 6)) {
            return false;        
        } else {
            return true;
        }

    }

    validateIcUser(formValue) {
        this.checkIC = true;
        let month = (formValue.kad_pengenalan) ? formValue.kad_pengenalan.substring(2, 4) : 0;
        let day = (formValue.kad_pengenalan) ? formValue.kad_pengenalan.substring(4, 6) : 0;
        let lengthIC = 0;
        let removeUndscr = (formValue.kad_pengenalan) ? (formValue.kad_pengenalan).replace(/\_/g, "") : 0;
        lengthIC = removeUndscr.length;

        if (lengthIC < 14 || lengthIC == undefined) {
            this.checkIC = true;
        }

        else {
            this.checkIC = this.validateIc(month, day);
        }
    }

    validateIc(m, d) {

        let validIC: any;
        let year = (this.citizenFormGrp.controls.kad_pengenalan.value) ? this.citizenFormGrp.controls.kad_pengenalan.value.substring(0, 2) : 0;
        let dateFormat = 'DD-MM-YYYY';
        let validIC19 = '19' + year + '-' + m + '-' + d;
        let validIC20 = '20' + year + '-' + m + '-' + d;
        let valM = moment(moment(validIC19).format(dateFormat), dateFormat, true).isValid();
        let valD = moment(moment(validIC20).format(dateFormat), dateFormat, true).isValid();

        if (valM == false && valD == false)
            validIC = false;
        else
            validIC = true;
        /*
        if (valM == false || valD == false)
            validIC = false;

        else
            validIC = true;
        */
        return validIC;
    }

    isPRTR() {
        if ((this.citizenValue == 3) || (this.citizenValue == 4) || (this.citizenValue == 7) || (this.citizenValue == 8)) {
            return true;
        } else {
            return false;
        }

    }

    getCountryName(sort) {
        return this.sharedService.getCountryData(null,sort)
            .subscribe(resCountryData => {
                let nameList = JSON.parse(JSON.stringify(resCountryData)).sort(this.predicateBy("countryCode"));
                let codeList = JSON.parse(JSON.stringify(resCountryData)).sort(this.predicateBy("countryName"));
                this.countries = nameList;
                this.countriesCode = codeList;
                this.filteredCountries = JSON.parse(JSON.stringify(this.countries)).sort(this.predicateBy("countryCode"));
                this.filteredCountriesName = JSON.parse(JSON.stringify(this.countriesCode)).sort(this.predicateBy("countryName"));    
            });
    }

    
    predicateBy(prop) {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }
    }

    resetCountryFilter() {
        this.filteredCountriesName = JSON.parse(JSON.stringify(this.countries)).sort(this.predicateBy("countryName"));
    }

    resetCountryCodeFilter() {
        this.filteredCountries = JSON.parse(JSON.stringify(this.countriesCode)).sort(this.predicateBy("countryCode"));
    }

    phoneKeyPress(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        //console.log(inputChar);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    filterDropDownName(val) {
        // console.log({'val':val});
        let keyword = val.toUpperCase();
        let anotherArray = JSON.parse(JSON.stringify(this.countries)).sort(this.predicateBy("countryName"));
        this.filteredCountriesName = anotherArray.filter((countries) => countries.countryCode.indexOf(keyword) > -1 || countries.countryDialCode.indexOf(keyword) > -1 || (countries.countryName).toUpperCase().indexOf(keyword) > -1); 
    }

    filterDropDown(val) {
        let keyword = val.toUpperCase();
        let anotherArray = JSON.parse(JSON.stringify(this.countriesCode)).sort(this.predicateBy("countryCode"));
        //console.log(anotherArray);
        //console.log(keyword);
        if (val.length < 3)
            this.filteredCountries = anotherArray.filter((countries) => countries.countryCode.indexOf(keyword) > -1 || countries.countryDialCode.indexOf(keyword) > -1);
        else {
            this.filteredCountries = anotherArray.filter((countries) => countries.countryCode.indexOf(keyword) > -1 || countries.countryDialCode.indexOf(keyword) > -1 || (countries.countryName).toUpperCase().indexOf(keyword) > -1);
        }
    }

    // PR and TR country change
    countryChange(e) {
        //let flr = this.countries.filter((element, index) => {
        //    return (element.countryId === e.value);
        //});
        //this.citizenFormGrp.get('codeTelefon').setValue(flr[0].countryDialCode);
        this.sharedService.loadFontSizeData();
        this.sharedService.loadFontTypeData();
    }

    countryChangeNonCiti(e) {
        let flr = this.countries.filter((element, index) => {
            return (element.countryId === e.value);
        });
        this.citizenFormGrp.get('codeTelefonf').setValue(flr[0].countryDialCode);
        this.sharedService.loadFontSizeData();
        this.sharedService.loadFontTypeData();
    }

    validateCtrlChk(ctrl: FormControl) {
        // return ctrl.valid || ctrl.untouched
        return this.validateService.validateCtrl(ctrl);
    }

    resetMethod(event) {
        this.resetForm();
        
    }

}








// WEBPACK FOOTER //
// ./src/app/register/register.component.ts